import { createAction } from '../../../utils/actions';

export const PAYMENT_DATA = 'PAYMENT_DATA';
export const PAYMENT_SUBMIT = 'PAYMENT_SUBMIT';
export const PAYMENT_VALUE_UPDATED = 'PAYMENT_VALUE_UPDATED';
export const PAYMENT_POLICY_AGREED = 'PAYMENT_POLICY_AGREED';

export const fetchPaymentData = (productId, data) => (dispatch, getState, container) => dispatch(
    createAction(PAYMENT_DATA, container().api.products.getPaymentData(productId, data))
);

export const valueUpdated =  (key, value) => createAction(PAYMENT_VALUE_UPDATED, { key, value });

export const postPayment = (productId, data) => (dispatch, getState, container) => dispatch(
    createAction(
        PAYMENT_SUBMIT,
        container().api.products.createPayment(productId, data)
            .catch(error => {
                // Don't refetch payment data on validation error to preserve user input
                // Only refetch on network errors or other non-validation errors
                if (error.status && error.status !== 400) {
                    dispatch(fetchPaymentData(productId));
                }
                throw error;
            })
    )
);



// WEBPACK FOOTER //
// ./src/portal/payment/actions/index.js